ACC.address = {

	_autoload: [
		'init',
		"bindToChangeAddressButton",
		"bindCreateUpdateAddressForm",
		"bindSuggestedDeliveryAddresses",
		"bindCountrySpecificAddressForms",
		"showAddressFormButtonPanel",
		"bindViewAddressBook",
		"bindToColorboxClose",
		"showRemoveAddressFromBookConfirmation",
		"backToListAddresses",
		"toggleAddressSubmit",
		"toggleCheckbox",
		"checkIfAddressSelected",
		"inputControl"
	],

	spinner: $("<img class='amds-loader-img' src='" + ACC.config.commonResourcePath + "/images/loader.svg' />"),
	addressID: '',
	init: function () {
		$('#popinChangeCheckoutAddressForm').modal({backdrop: 'static', keyboard: true});
	},
	handleChangeAddressButtonClick: function () {
		ACC.address.addressID = ($(this).data("address")) ? $(this).data("address") : '';
		$('#summaryDeliveryAddressFormContainer').show();
		$('#summaryOverlayViewAddressBook').show();
		$('#summaryDeliveryAddressBook').hide();

		$.getJSON(getDeliveryAddressesUrl, ACC.address.handleAddressDataLoad);
		return false;
	},

	handleAddressDataLoad: function (data) {
		ACC.address.setupDeliveryAddressPopupForm(data);

		// Show the delivery address popup
		ACC.colorbox.open("",{
		 	inline: true,
			href: "#summaryDeliveryAddressOverlay",
			overlayClose: false,
			onOpen: function (){
				// empty address form fields
				ACC.address.emptyAddressForm();
				$(document).on('change', '#saveAddress', function ()
				{
					var saveAddressChecked = $(this).prop('checked');
					$('#defaultAddress').prop('disabled', !saveAddressChecked);
					if (!saveAddressChecked)
					{
						$('#defaultAddress').prop('checked', false);
					}
				});
			}
		});
	},

	setupDeliveryAddressPopupForm: function (data)
	{
		// Fill the available delivery addresses
		$('#summaryDeliveryAddressBook').html($('#deliveryAddressesTemplate').tmpl({addresses: data}));
		// Handle selection of address
		$('#summaryDeliveryAddressBook button.use_address').click(ACC.address.handleSelectExistingAddressClick);
		// Handle edit address
		$('#summaryDeliveryAddressBook button.edit').click(ACC.address.handleEditAddressClick);
		// Handle set default address
		$('#summaryDeliveryAddressBook button.default').click(ACC.address.handleDefaultAddressClick);
	},

	emptyAddressForm: function ()
	{
		var options = {
			url: getDeliveryAddressFormUrl,
			data: {addressId: ACC.address.addressID, createUpdateStatus: ''},
			type: 'GET',
			success: function (data)
			{
				$('#summaryDeliveryAddressFormContainer').html(data);
				ACC.address.bindCreateUpdateAddressForm();
			}
		};

		$.ajax(options);
	},
	serializeJSON: function(form, formToserialize) {
    		var json = {};
    		jQuery.map($(form).serializeArray(), function(n, _) {
       		 if ((n['name']).indexOf(formToserialize) == 0) {
            		json[n['name']] = n['value'];
       		 }
    	});
    return JSON.stringify(json);
},

	handleSelectExistingAddressClick: function ()
	{
		var addressId = $(this).attr('data-address');
		$.postJSON(setDeliveryAddressUrl, {addressId: addressId}, ACC.address.handleSelectExitingAddressSuccess);
		return false;
	},

	handleEditAddressClick: function ()
	{

		$('#summaryDeliveryAddressFormContainer').show();
		$('#summaryOverlayViewAddressBook').show();
		$('#summaryDeliveryAddressBook').hide();

		var addressId = $(this).attr('data-address');
		var options = {
			url: getDeliveryAddressFormUrl,
			data: {addressId: addressId, createUpdateStatus: ''},
			target: '#summaryDeliveryAddressFormContainer',
			type: 'GET',
			success: function (data)
			{
				ACC.address.bindCreateUpdateAddressForm();
				ACC.colorbox.resize();
			},
			error: function (xht, textStatus, ex)
			{
				alert("Failed to update cart. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
			}
		};

		$(this).ajaxSubmit(options);
		return false;
	},

	handleDefaultAddressClick: function ()
	{
		var addressId = $(this).attr('data-address');
		var options = {
			url: setDefaultAddressUrl,
			data: {addressId: addressId},
			type: 'GET',
			success: function (data)
			{
				ACC.address.setupDeliveryAddressPopupForm(data);
			},
			error: function (xht, textStatus, ex)
			{
				alert("Failed to update address book. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
			}
		};

		$(this).ajaxSubmit(options);
		return false;
	},

	saveFormToCookie : function (form,formToserialize) {
		var name = $(form).attr('id');
		var data = ACC.address.serializeJSON(form,formToserialize);
		$.cookie(name, data, {expires: 365});

	},

	serializeJSON : function (form, formToserialize) {

		var json = {};
		jQuery.map($(form).serializeArray(), function (n, _) {
			if((n['name']).indexOf(formToserialize) == 0){
				json[n['name']] = n['value'];
			}
		});
		return JSON.stringify(json);

	},

	handleSelectExitingAddressSuccess: function (data)
	{
		if (data != null)
		{
			ACC.refresh.refreshPage(data);
			ACC.colorbox.close();
		}
		else
		{
			alert("Failed to set delivery address");
		}
	},

	bindCreateUpdateAddressForm: function ()
	{
		$('.create_update_address_form').each(function ()
		{
			var options = {
				type: 'POST',
				beforeSubmit: function ()
				{
					$('#checkout_delivery_address').block({ message: ACC.address.spinner });
				},
				success: function (data)
				{
					$('#summaryDeliveryAddressFormContainer').html(data);
					var status = $('.create_update_address_id').attr('status');
					if (status != null && "success" === status.toLowerCase())
					{
						ACC.refresh.getCheckoutCartDataAndRefreshPage();
						ACC.colorbox.close();
					}
					else
					{
						ACC.address.bindCreateUpdateAddressForm();
						ACC.colorbox.resize();
					}
				},
				error: function (xht, textStatus, ex)
				{
					alert("Failed to update cart. Error details [" + xht + ", " + textStatus + ", " + ex + "]");
				},
				complete: function ()
				{
					$('#checkout_delivery_address').unblock();
				}
			};

			$(this).ajaxForm(options);
		});
	},

	refreshDeliveryAddressSection: function (data)
	{
		$('.summaryDeliveryAddress').replaceWith($('#deliveryAddressSummaryTemplate').tmpl(data));

	},

	bindSuggestedDeliveryAddresses: function ()
	{
		var status = $('.add_edit_delivery_address_id').attr('status');
		if (status != null && "hasSuggestedAddresses" == status)
		{
			ACC.address.showSuggestedAddressesPopup();
		}
	},

	showSuggestedAddressesPopup: function ()
	{

		ACC.colorbox.open("",{
			href: "#popup_suggested_delivery_addresses",
			inline: true,
			overlayClose: false,
			width: 525,
		});
	},

	bindCountrySpecificAddressForms: function (){
		$(document).on("change",'#countrySelector select', function (){
			var options = {
				'addressCode': '',
				'countryIsoCode': $(this).val()
			};
			ACC.address.displayCountrySpecificAddressForm(options, ACC.address.showAddressFormButtonPanel);
		})

	},

	showAddressFormButtonPanel: function ()
	{
		if ($('#countrySelector :input').val() !== '')
		{
			$('#addressform_button_panel').show();
		}
	},

	bindToColorboxClose: function ()
	{
		$(document).on("click", ".closeColorBox", function ()
		{
			ACC.colorbox.close();
		})
	},


	displayCountrySpecificAddressForm: function (options, callback)
	{
		$.ajax({
			url: ACC.config.encodedContextPath + '/my-account/addressform',
			async: true,
			data: options,
			dataType: "html",
			beforeSend: function ()
			{
				$("#i18nAddressForm").html(ACC.address.spinner);
			}
		}).done(function (data)
				{
					$("#i18nAddressForm").html($(data).html());
					if (typeof callback == 'function')
					{
						callback.call();
					}
				});
	},

	bindToChangeAddressButton: function ()
	{
		$(document).on("click", '.summaryDeliveryAddress .editButton', ACC.address.handleChangeAddressButtonClick);
	},

	bindViewAddressBook: function ()
	{
		var title = $('.savedAddress-title').html();

		$(document).on("click",".js-address-book",function(e){
			e.preventDefault();

			ACC.colorbox.open(title, {
				href: "#addressbook",
				inline: true,
				width: "380px",
				maxWidth: "380px",
				maxHeight: "697px",
				fixed: true,
				class: "shippingBox",

				onOpen: function () {
					$('html,body').addClass('fixBodyScroll');

					$("#addressbook").perfectScrollbar({
						useBothWheelAxes: false,
		        suppressScrollX: true
					});
					$("#colorbox").addClass("shippingBox");
				},

				onComplete: function() {
					$("#addressbook").scrollTop(1);
				},

				onClosed: function() {
					$('html,body').removeClass('fixBodyScroll');
					$("#colorbox").removeClass("shippingBox");
				}
			});
		});

		$(window).on("resize scroll", function(e){
			// ACC.colorbox.resize();
		});

		$(document).on("click",".js-address-book-billing",function(e){
			e.preventDefault();

			ACC.colorbox.open(title, {
				href: "#billingaddressbook",
				inline: true,
				width: "380px",
				maxWidth: "380px",
				maxHeight: "697px",
				fixed: true,
				class: "billingPopin",

				onOpen: function () {
					$('html,body').addClass('fixBodyScroll');

					$("#billingaddressbook").perfectScrollbar({
						useBothWheelAxes: false,
		        suppressScrollX: true
					});
					$("#colorbox").addClass("billingBox");

				},

				onComplete: function() {
					// ACC.colorbox.resize();
					$("#billingaddressbook").scrollTop(1);
				},

				onClosed: function() {
					$('html,body').removeClass('fixBodyScroll');
					$("#colorbox").removeClass("billingBox");
				}
			});
		});

		$(document).on("click", '#summaryOverlayViewAddressBook', function () {
			$('#summaryDeliveryAddressFormContainer').hide();
			$('#summaryOverlayViewAddressBook').hide();
			$('#summaryDeliveryAddressBook').show();
			ACC.colorbox.resize();
		});
	},

	showRemoveAddressFromBookConfirmation: function ()
	{
		$(document).on("click", ".removeAddressFromBookButton", function ()
		{
			var addressId = $(this).data("addressId");
			var popupTitle = $(this).data("popupTitle");

			ACC.colorbox.open(popupTitle,{
				inline: true,
				height: false,
				fixed: true,
				href: "#popup_confirm_address_removal_" + addressId,
				onComplete: function ()
				{

					$(this).colorbox.resize();
				}
			});

		})
	},

	backToListAddresses: function(){
		$(".addressBackBtn").on("click", function(){
			var sUrl = $(this).data("backToAddresses");
			window.location = sUrl;
		});
	},

	toggleAddressSubmit: function () {
		$("#certify, #transportCostsAccepted").on("change", ACC.address.updateAddressSubmit);
		ACC.address.updateAddressSubmit();
		$(window).on("pageshow", ACC.address.updateAddressSubmit);
		$("#addressForm").on("submit", ACC.address.validateAddressAcknowledgements);
		$("#addressSubmit").add($(".checkout-steps .step-block.active").nextAll().find(".js-checkout-step"))
			.on("click", ACC.address.validateAddressAcknowledgements);
	},

	updateAddressSubmit: function () {
		if (ACC.address.isDeliveryAddressRequired()) {
			$(".btn-amds.change_address_button").prop("disabled", true);
			return;
		}
		var acknowledgements = $("#certify, #transportCostsAccepted").filter(function () {
			return $(this).closest(".certifyCheckbox").css("display") !== "none";
		});
		if (acknowledgements.length) {
			$(".btn-amds.change_address_button").prop("disabled", acknowledgements.filter(":not(:checked)").length > 0);
		}
	},

	isDeliveryAddressRequired: function () {
		return $(".checkout-shipping").attr("data-delivery-address-required") === "true";
	},

	isAddressRemovalSubmit: function (event) {
		var submitter = event.originalEvent && event.originalEvent.submitter;
		return event.type === "submit" && $(submitter).is("#addressForm .btn-remove.delete[formnovalidate][name='addressCode']");
	},

	validateAddressAcknowledgements: function (event) {
		if (ACC.address.isAddressRemovalSubmit(event)) {
			return true;
		}
		if (ACC.address.isDeliveryAddressRequired()) {
			event.preventDefault();
			event.stopImmediatePropagation();
			ACC.address.updateAddressSubmit();
			return false;
		}
		var acknowledgement = $("#addressForm #certify:not(:checked), #transportCostsAccepted:not(:checked)").filter(function () {
			return $(this).closest(".certifyCheckbox").css("display") !== "none";
		})[0];
		if (acknowledgement) {
			event.preventDefault();
			event.stopImmediatePropagation();
			ACC.address.updateAddressSubmit();
			acknowledgement.focus();
			acknowledgement.reportValidity();
			return false;
		}
	},

	toggleCheckbox: function () {
		$("#certify,#defaultAddress,#transportCostsAccepted").on("change", function () {
			if($(this).is(':checked')) {
				$(this).parent().siblings("div").find('.inputCheckbox').addClass("checked");
			} else {
				$(this).parent().siblings("div").find('.inputCheckbox').removeClass("checked");
			}
		});
	},

	checkIfAddressSelected: function () {
		if($(".checkout-summary-address").length > 0 && $(".addShippingAddress").length == 0) {
			$(".btn-amds.change_address_button").removeAttr("disabled");
			$(".certifyCheckbox:not(.transportCostsCheckbox)").not("#addressForm .certifyCheckbox").hide();
			ACC.address.updateAddressSubmit();
		}
	},
	inputControl: function (){
		$(document).on('keyup', '#addAddressForm input.amds-form-field__input, #review-form .form-group .form-control', function () {
			$(this).css({"border":"1px solid #ff3700"});
		})
		$(document).on('focusout', '#addAddressForm input.amds-form-field__input, #review-form .form-group .form-control', function () {
			$(this).css({"border":"1px #414141 solid"});	
		})
		$(document).on('focusout', '#addAddressForm input.amds-form-field__input#postcode', function () {
			if($("#addAddressForm input.amds-form-field__input#postcode").not(".hasError") && $("#addAddressForm input.amds-form-field__input#postcode").not(".hasError").val()!=""){
				$("#addAddressForm input.amds-form-field__input#postcode").not(".hasError").after(`<span class="svg-style"><svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3 6.83158L6.20833 10L12.625 3" stroke="#EC4A27" stroke-width="3" stroke-linecap="square"/></svg></span>`);
			}
		})
		$(document).on('keyup', '#addAddressForm input.amds-form-field__input#postcode', function () {
			$('.svg-style').addClass('hidden');
		})
	}
};
